import React, { useState, useEffect } from "react";
// Tutte le chiamate, DELETE compreso, passano dal client api.js (che antepone
// l'indirizzo del backend e allega il token dell'utente). Il DELETE manda l'id
// nel corpo: api.del accetta un corpo facoltativo (api.js, cantiere CLINICS C2).
import { api } from "../api/api";
import "./ManageModalQPSC.css";

export default function ManageContactsModal({ isOpen, onClose, onChanged }) {
  const [contacts, setContacts] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editContact, setEditContact] = useState(null);
  const [newContact, setNewContact] = useState({
    isCompany: true,
    companyName: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    referenceName: ""
  });
  const [viewProfile, setViewProfile] = useState(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    if (isOpen) loadContacts();
  }, [isOpen]);

  const loadContacts = async () => {
    const data = await api.get("/contacts");
    setContacts(data || []);
  };

  const handleInput = (target, value) => {
    setNewContact((prev) => ({ ...prev, [target]: value }));
  };

  const handleAdd = async () => {
    setError("");
    setSuccess("");
    if (
      (newContact.isCompany && !newContact.companyName.trim()) ||
      (!newContact.isCompany &&
        (!newContact.firstName.trim() || !newContact.lastName.trim()))
    ) {
      setError("Name/Company is required!");
      return;
    }
    // Controllo unicità (case-insensitive)
    if (
      contacts.some((c) =>
        newContact.isCompany
          ? c.isCompany &&
            c.companyName &&
            c.companyName.trim().toLowerCase() === newContact.companyName.trim().toLowerCase()
          : !c.isCompany &&
            c.firstName &&
            c.lastName &&
            c.firstName.trim().toLowerCase() === newContact.firstName.trim().toLowerCase() &&
            c.lastName.trim().toLowerCase() === newContact.lastName.trim().toLowerCase()
      )
    ) {
      setError("Name/Company must be unique.");
      return;
    }
    try {
      await api.post("/contacts", newContact);
      setNewContact({
        isCompany: true,
        companyName: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        referenceName: ""
      });
      setSuccess("Client/Supplier added!");
      loadContacts();
      onChanged && onChanged();
      setTimeout(() => setSuccess(""), 2000);
    } catch (e) {
      setError("Error while adding client/supplier.");
    }
  };

  const handleEditSave = async (idx) => {
    setError("");
    setSuccess("");
    if (
      (editContact.isCompany && !editContact.companyName.trim()) ||
      (!editContact.isCompany &&
        (!editContact.firstName.trim() || !editContact.lastName.trim()))
    ) {
      setError("Name/Company is required!");
      return;
    }
    // Controllo unicità su edit, ignora il proprio indice
    if (
      contacts.some((c, i) =>
        i !== idx
          ? editContact.isCompany
            ? c.isCompany &&
              c.companyName &&
              c.companyName.trim().toLowerCase() === editContact.companyName.trim().toLowerCase()
            : !c.isCompany &&
              c.firstName &&
              c.lastName &&
              c.firstName.trim().toLowerCase() === editContact.firstName.trim().toLowerCase() &&
              c.lastName.trim().toLowerCase() === editContact.lastName.trim().toLowerCase()
          : false
      )
    ) {
      setError("Name/Company must be unique.");
      return;
    }
    try {
      await api.put("/contacts", {
        original: contacts[idx],
        updated: editContact,
      });
      setEditingIndex(null);
      setEditContact(null);
      setSuccess("Client/Supplier updated!");
      loadContacts();
      onChanged && onChanged();
      setTimeout(() => setSuccess(""), 2000);
    } catch (e) {
      setError("Error while updating client/supplier.");
    }
  };

  const handleEdit = (idx) => {
    setEditingIndex(idx);
    setEditContact({ ...contacts[idx] });
    setError("");
    setSuccess("");
  };

  const handleDelete = async (idx) => {
    setError("");
    setSuccess("");
    if (!window.confirm("Delete this client/supplier?")) return;
    try {
      await api.del("/contacts", { id: contacts[idx].id });
      setSuccess("Client/Supplier deleted.");
      loadContacts();
      onChanged && onChanged();
      setTimeout(() => setSuccess(""), 2000);
    } catch (e) {
      setError("Error while deleting client/supplier.");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modalqpsc-overlay">
      <div className="modalqpsc-window big">
        <div className="modalqpsc-header">
          <h3>Manage Clients & Suppliers</h3>
          <button className="modalqpsc-close" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="modalqpsc-body modalqpsc-scroll">
          {error && <div className="modalqpsc-error">{error}</div>}
          {success && <div className="modalqpsc-success">{success}</div>}
          <table className="modalqpsc-table">
            <thead>
              <tr>
                <th style={{ minWidth: 140, color: "#d21f25", fontStyle: "italic" }}>Company/Name</th>
                <th style={{ width: 225, color: "#d21f25", fontStyle: "italic" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {contacts.map((c, i) => (
                <tr key={i}>
                  <td>
                    <div>
                      <div style={{ fontWeight: 600 }}>
                        {c.isCompany && c.companyName
                          ? c.companyName
                          : `${c.firstName || ""} ${c.lastName || ""}`}
                      </div>
                      <div style={{
                        display: "flex", gap: 12, fontSize: "0.99em", color: "#ffe7a0", marginTop: 2
                      }}>
                        <span>{c.email}</span>
                        <span>{c.phone}</span>
                        {c.isCompany && <span>{c.referenceName}</span>}
                      </div>
                    </div>
                  </td>
                  <td style={{ display: "flex", gap: 7 }}>
                    {editingIndex === i ? (
                      <>
                        <button className="modalqpsc-btn gold" onClick={() => handleEditSave(i)}>Save</button>
                        <button className="modalqpsc-btn" onClick={() => setEditingIndex(null)}>Cancel</button>
                      </>
                    ) : (
                      <>
                        <button className="modalqpsc-btn gold" onClick={() => handleEdit(i)}>Edit</button>
                        <button className="modalqpsc-btn red" onClick={() => handleDelete(i)}>Delete</button>
                        <button className="modalqpsc-btn" onClick={() => setViewProfile(c)}>View Profile</button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
              {/* ADD */}
              <tr>
                <td>
                  <div style={{ marginBottom: 8 }}>
                    <label style={{ marginRight: 14 }}>
                      <input
                        type="radio"
                        checked={newContact.isCompany}
                        onChange={() => handleInput("isCompany", true)}
                      /> Company
                    </label>
                    <label>
                      <input
                        type="radio"
                        checked={!newContact.isCompany}
                        onChange={() => handleInput("isCompany", false)}
                      /> Person
                    </label>
                  </div>
                  {newContact.isCompany ? (
                    <input
                      type="text"
                      value={newContact.companyName}
                      onChange={e => handleInput("companyName", e.target.value)}
                      className="modalqpsc-input"
                      placeholder="Company Name"
                      style={{ marginBottom: 10, width: "60%" }}
                    />
                  ) : (
                    <div style={{ display: "flex", gap: 10, marginBottom: 10 }}>
                      <input
                        type="text"
                        value={newContact.firstName}
                        onChange={e => handleInput("firstName", e.target.value)}
                        className="modalqpsc-input"
                        placeholder="First Name"
                      />
                      <input
                        type="text"
                        value={newContact.lastName}
                        onChange={e => handleInput("lastName", e.target.value)}
                        className="modalqpsc-input"
                        placeholder="Last Name"
                      />
                    </div>
                  )}
                  <div style={{ display: "flex", gap: 10 }}>
                    <input
                      type="text"
                      value={newContact.email}
                      onChange={e => handleInput("email", e.target.value)}
                      className="modalqpsc-input"
                      placeholder="Email"
                      style={{ width: "32%" }}
                    />
                    <input
                      type="text"
                      value={newContact.phone}
                      onChange={e => handleInput("phone", e.target.value)}
                      className="modalqpsc-input"
                      placeholder="Phone"
                      style={{ width: "22%" }}
                    />
                    <input
                      type="text"
                      value={newContact.referenceName}
                      onChange={e => handleInput("referenceName", e.target.value)}
                      className="modalqpsc-input"
                      placeholder="Contact Person"
                      style={{ width: "32%" }}
                    />
                  </div>
                </td>
                <td>
                  <button className="modalqpsc-btn" onClick={handleAdd}>Add</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {viewProfile && (
          <div className="modalqpsc-profile-modal">
            <div className="modalqpsc-header">
              <h3 style={{ color: "#d21f25" }}>
                {viewProfile.isCompany ? viewProfile.companyName : `${viewProfile.firstName} ${viewProfile.lastName}`}
              </h3>
              <button className="modalqpsc-close" onClick={() => setViewProfile(null)}>✕</button>
            </div>
            <div className="modalqpsc-profile-body">
              <div><b>Email:</b> {viewProfile.email || "-"}</div>
              <div><b>Phone:</b> {viewProfile.phone || "-"}</div>
              {viewProfile.isCompany && <div><b>Reference:</b> {viewProfile.referenceName || "-"}</div>}
              <div style={{ marginTop: 8 }}>
                <button className="modalqpsc-btn" onClick={() => setViewProfile(null)}>Close</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}